<script lang="ts">
    import { page } from '$app/stores';
    import { spineBus } from '$src/lib/services/gatekeeper/MessageBus';
    import { pushEvent } from '$src/lib/services/gtm';
    import { onMount } from 'svelte';

    onMount(() => {
        const { unsubscribe } = spineBus.subscribe(
            'analytics',
            ({ kind, names, data }, { source }) => {
                if (kind === 'gtm' && data) {
                    const { isCasumoProd } = $page.data;
                    if (!isCasumoProd) {
                        console.info('analytics - google tag recorded:', data);
                    }

                    const event = `fabric.${names.feature || source}.${names.action}`;
                    pushEvent(event, data);
                }
            }
        );
        return unsubscribe;
    });
</script>
